import * as Utils from '@standardnotes/utils';
export class CreateConsistentBase64JsonPayloadUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(jsonObject) {
        return this.crypto.base64Encode(JSON.stringify(Utils.sortedCopy(Utils.omitUndefinedCopy(jsonObject))));
    }
}
